import script from "./ClubGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubGallery.vue?vue&type=script&setup=true&lang=js"

import "./ClubGallery.vue?vue&type=style&index=0&id=2ba84c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba84c80"]])

export default __exports__